import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PayPalButtons } from "@paypal/react-paypal-js";

import PayPal from '@images/svg-icons/paypal.svg';
import { animateTextBanner } from '@utils/utils';

type PayPalButtonProps = {
    onApproveUrl: string;
    onReturnUrl: string;
    smartGlassesError?: string;
}

const PayPalButton = (props: PayPalButtonProps): ReactElement => {

    const {
        onApproveUrl,
        onReturnUrl,
        smartGlassesError = ''
    } = props;

    var paymentSelected="";

    const config = useSelector(state => state.cart.config);
    const cart = useSelector(state => state.cart.cart);

    const speedyOrderDetails = useSelector(state => state.cart.speedyOrderDetails);
    const [isOrderSpeedyErrorActive, setIsOrderSpeedyErrorActive] = useState(false);

    useEffect(() => {
        window.paypal_disabled = false;
    }, []);

    useEffect(() => {
        if(config.isSpeedyRxEnabled === 'true' && !!speedyOrderDetails){
            if(!!speedyOrderDetails.orderSpeedyActive && speedyOrderDetails.mixedCart === true){
                setIsOrderSpeedyErrorActive(true);
            } else {
                setIsOrderSpeedyErrorActive(false);
            }
        }
    }, [speedyOrderDetails])

    return (
        <div id={"paypal-button"}>
            {smartGlassesError.length === 0 && isOrderSpeedyErrorActive === false ?
                <PayPalButtons style={
                    {
                        color: 'white',
                        shape: 'rect',
                        label: 'paypal',
                        layout: 'horizontal',
                        height: 40,
                        tagline: false,
                    }}
                    createOrder={() => {
                        if(!window.paypal_disabled){
                            window.paypal_disabled = true;

                            const url = onApproveUrl.replace('{{0}}', config.catalogId)
                                            .replace('{{1}}', config.langId)
                                            .replace('{{2}}', config.storeId)
                                            .replace('{{3}}', cart.orderId);

                            // You'll configure this in the following steps.
                            return fetch(config.hostname + url, {method: 'POST'})
                            .then(function(res) {
                                // 3. Return res.id from the response
                                return res.json();
                            }).then(function(responseData) {
                                if(responseData.id != undefined) {
                                    console.log(paymentSelected);
                                    let paymentMethod="PayPal";
                                    if(paymentSelected=='venmo'){
                                        paymentMethod="VenmoExpressCheckout"
                                    }
                                    localStorage.setItem('paymentIdPaypal',paymentMethod);
                                        
                                    return responseData.id;
                                } else {
                                    return false;
                                }
                            });
                        }
                    }}
                    onClick={(data, actions) => {
                        paymentSelected=String(data.fundingSource);
                    }}
                    onApprove={(data, actions) => {
                        window.paypal_disabled = false;
                        const url = onReturnUrl.replace('{{0}}', cart.orderId)
                            .replace('{{1}}', config.catalogId)
                            .replace('{{2}}', config.storeId)
                            .replace('{{3}}', data.orderID);

                        return fetch(config.hostname + url)
                        .then(function(resp) {
                            if(resp.url != undefined) {
                            actions.redirect(resp.url);
                            }
                        });
                    }}
                    onCancel={() => {
                        window.paypal_disabled = false;
                        window?.tealium_data2track?.push({
                            id: 'Event',
                            Events_Error: '1',
                            Error_Code: 'Paypal Exp cancelled',
                            Error_Details: 'Paypal Exp cancelled',
                            Error_Source: 'User',
                            Error_Message: 'Paypal Exp cancelled'
                        });
                    }}
                    onError={(error) => {
                        // You will want to handle this differently
                        window.paypal_disabled = false;
                        window?.tealium_data2track?.push({
                            id: 'Event',
                            Events_Error: '1',
                            Error_Code: 'Checkout - Payment',
                            Error_Details: 'Paypal express',
                            Error_Source: 'Server',
                            Error_Message: 'Paypal Express checkout error'
                        });
                        return console.error(error.message);
                    }}
                /> :
                <div className="paypal-button-placeholder disabled" onClick={() => animateTextBanner()}>
                    <PayPal />
                </div>
            }
           
        </div>
    )
}

export default PayPalButton;
